'use client';

import { memo as Memo, useRef, useCallback, useEffect, useState } from 'react';

//* HOC's
import withUIContext from '@context/consumerHOC/UIConsumer';

//* Components
import Page from '@components/global/Page';
import HTMLContainer from '@components/global/HTMLContainer';
import AnimationWrap from '@components/global/AnimationWrap';
import TeamForm from '@components/pages/ContactTeam/TeamForm';
import OpenRoles from '@components/pages/ContactTeam/OpenRoles';
import PageTopSection from '@components/pages/Contact/PageTopSection';

//* Styles
import TeamStyle from '@/styles/pages/TeamStyle';

const Team = Memo(({ pageData, toggleLightHeader }) => {
    //! States
    const [secObj1, setSecObj1] = useState();
    const [secObj, setSecObj] = useState(false);

    //! Refs
    const sec1 = useRef();
    const teamContRef = useRef();

    //! Handle Active Section Animation
    const Anim = useCallback(
        (x) => {
            if (JSON.stringify(x) !== JSON.stringify(secObj1)) {
                setSecObj1(x);
            }
        },
        [secObj1]
    );

    const sectionAnimation = useCallback(() => {
        if (sec1.current) {
            const elTop = sec1?.current?.getBoundingClientRect().top;
            const pointStart = window.innerHeight / 10;

            if (elTop < pointStart && !secObj) {
                setSecObj(true);
            } else if (elTop >= pointStart && secObj) {
                setSecObj(false);
            }
        }
    }, [sec1, secObj]);

    useEffect(() => {
        window.addEventListener('scroll', sectionAnimation);

        return () => {
            window.removeEventListener('scroll', sectionAnimation);
        };
    }, [sectionAnimation]);

    //! Reversed Header
    useEffect(() => {
        toggleLightHeader('reversed');
    }, []);

    //! Scroll To From Function
    const onClick = useCallback(() => {
        window.scrollTo({
            top: teamContRef?.current?.getBoundingClientRect().y + window.scrollY,
            behavior: 'smooth',
        });
    }, []);

    return (
        <Page className={'mainBack'}>
            <TeamStyle>
                <div className={'ContactTeemCont'}>
                    <HTMLContainer>
                        <div className='section-item'>
                            <PageTopSection
                                type={2}
                                time={1000}
                                pageTop={pageData.hero}
                                onOtherInfoClick={onClick}
                            />
                        </div>

                        <AnimationWrap state={Anim}>
                            <div className={`section-item OpenRoles`}>
                                <OpenRoles
                                    onClick={onClick}
                                    active={secObj1?.sec1}
                                    teamFormRoles={pageData.open_roles}
                                />
                            </div>

                            <div
                                ref={teamContRef}
                                className='section-item'>
                                <TeamForm
                                    active={secObj1?.sec2}
                                    title={pageData.form_title}
                                />
                            </div>
                        </AnimationWrap>
                    </HTMLContainer>
                </div>
            </TeamStyle>
        </Page>
    );
});

export default withUIContext(Team, ['toggleLightHeader']);
